import { RossNavigation } from 'src/@ross/types';


export const navigation: RossNavigation[] = [
    {
        id       : 'gestionLiq',
        title    : 'Gestión de Liquidaciones',
        type     : 'collapsable',
        icon     : 'briefcase-outline',
        hidden   : true,
        children : [
            {
                id   : 'liqAsignar',
                title: 'Liquidaciones por Asignar',
                type : 'item',
                url  : '/pages/management-liquidation/assigned'
            },
            {
                id   : 'liqActivas',
                title: 'Mis Liquidaciones',
                type : 'item',
                url  : '/pages/management-liquidation/active'
            },
            {
                id   : 'liqReport',
                title: 'Reporte de Liquidaciones',
                type : 'item',
                url  : '/pages/management-liquidation/report'
            },
        ]
    },
    {
        id       : 'gestionLiqActive',
        title    : 'Mis Liquidaciones',
        type     : 'item',
        icon     : 'briefcase-outline',
        hidden   : true,
        url  : '/pages/management-liquidation/active'
    },
    {
        id       : 'gestionPM',
        title    : 'Gestión de PM',
        type     : 'item',
        hidden   : true,
        icon     : 'account-convert',
        url  : '/pages/gestion-pm'
    },
    {
        id       : 'cautelares',
        title    : 'Cautelares',
        type     : 'collapsable',
        icon     : 'gavel',
        children : [
            {
                id       : 'soj',
                title    : 'SOJ',
                type     : 'collapsable',
                children : [
                    {
                        id   : 'misOficios',
                        title: 'Mis Oficios',
                        type : 'item',
                        url  : '/pages/precautionary/embargo/embargo-list'
                    },
                    {
                        id   : 'levantamientos',
                        title: 'Levantamientos',
                        type : 'item',
                        hidden   : true,
                        url  : '/pages/precautionary/embargo/cancellation'
                    }
                ],

            },
            {
                id       : 'dnrpa',
                title    : 'DNRPA',
                type     : 'collapsable',
                children : [
                    {
                        id   : 'misInhibiciones',
                        title: 'Mis Inhibiciones',
                        type : 'item',
                        url  : '/pages/precautionary/dnrpa/dnrpa-list'
                    },
                    {
                        id   : 'levantamientos-dnrpa',
                        title: 'Levantamientos',
                        type : 'item',
                        hidden   : true,
                        url  : '/pages/precautionary/dnrpa/dnrpa-cancellation'
                    }
                ],

            }
        ]
    },
    {
        id       : 'consultarExpediente',
        title    : 'Consultar Expediente',
        type     : 'item',
        hidden   : true,
        icon     : 'account-search',
        url      : '/pages/expediente'
    },
    {
        id       : 'consultarInformes',
        title    : 'Consultar Informes',
        type     : 'item',
        icon     : 'file-find',
        url      : '/pages/infoExperto'
    },
    {
        id       : 'consultarSOJ',
        title    : 'Consultar SOJ',
        type     : 'item',
        icon     : 'file-find',
        url      : '/pages/consultaSOJ'
    },
    {
        id       : 'notificaciones',
        title    : 'Notificaciones',
        type     : 'item',
        icon     : 'file',
        url      : '/pages/notificacion'
    },
    {
        id       : 'reportes',
        title    : 'Reportes',
        type     : 'item',
        icon     : 'chart-line',
        url      : '/pages/reporte'
    },
    {
        id       : 'documentacion',
        title    : 'Documentación',
        type     : 'item',
        icon     : 'folder',
        url  : '/pages/documentacion',
    },
    {
      id       : 'calendar',
      title    : 'Calendario',
      type     : 'item',
      icon     : 'folder',
      url  : '/pages/calendar',
  },
    {
        id       : 'capacitacion',
        title    : 'Capacitación',
        type     : 'item',
        icon     : 'book-open-page-variant',
        url  : 'https://capacitacion.rentascordoba.gob.ar',
        externalUrl: true,
        openInNewTab: true
    },
    {
        id       : 'transferencias',
        title    : 'Transferencias',
        type     : 'item',
        icon     : 'transfer-right',
        url  : 'pages/transfers',
    }

];
